import { Link } from "react-router-dom";
import { Tooltip } from "antd";
import CustomModal from "../../components/common/CustomModal";
import { FiPlus, FiHelpCircle } from "react-icons/fi";
import { PiEyeLight } from "react-icons/pi";
import { LiaEdit, LiaTrashAlt } from "react-icons/lia";
import Table from "../../components/Table";
import SelectDropdown from "../../components/common/SelectDropdown";
import shared from "./shared";
import Layout from "../../components/global/layout";
import methodModel from "../../methods/methods";
import { useSelector } from "react-redux";
import { statusModel } from "../../models/Status.model";
import { useState, useEffect } from "react";
import FormControl from "../../components/common/FormControl";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../methods/loader";
import { toast } from "react-toastify";
import { TbSend } from "react-icons/tb";
import { FaEdit, FaEye } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import DateRangePicker from "../../components/Charts/DateRangePicker";
import moment from "moment";

function Html({
  sorting,
  filter,
  edit,
  view,
  statusChange,
  pageChange,
  count,
  deleteItem,
  clear,
  filters,
  setFilter,
  loaging,
  data,
  changestatus,
  total,
  sortClass,
  dateFilterApplied,
  isDateSelecting,
  setIsDateSelecting,
}) {
  const user = useSelector((state) => state.user);
  const [SelectedUsers, setSelectedUsers] = useState([]);
  const [isHelpModalVisible, setIsHelpModalVisible] = useState(false);
  const [DateFilters, setDateFilters] = useState({
    startDate: moment().startOf("month").toDate(),
    endDate: moment().toDate(),
    key: "selection",
  });

  useEffect(() => {
    if (filters?.startDate && filters?.endDate) {
      setDateFilters({
        startDate: moment(filters.startDate).toDate(),
        endDate: moment(filters.endDate).toDate(),
        key: "selection",
      });
    }
  }, [filters?.startDate, filters?.endDate]);

  const handleDateRangeChange = (range) => {
    const startDate = moment(range.startDate).format("YYYY-MM-DD");
    const endDate = moment(range.endDate).format("YYYY-MM-DD");

    setDateFilters({
      ...range,
      key: "selection",
    });

    // First date selected
    if (startDate === endDate) {
      setIsDateSelecting(true);
      return;
    }

    // End date selected
    setIsDateSelecting(false);

    const updated = {
      ...filters,
      startDate,
      endDate,
      dateFilterApplied: true,
      page: 1,
    };

    setFilter(updated);

    filter({
      startDate,
      endDate,
      dateFilterApplied: true,
      page: 1,
    });
  };

  const CheckboxSelectorHandler = (checked, id) => {
    let data = SelectedUsers;
    if (checked) {
      data.push(id);
    } else {
      data = data.filter((item) => item != id);
    }
    setSelectedUsers([...data]);
  };
  const HandleSelectAll = (checked) => {
    if (checked) {
      setSelectedUsers(data?.map((item) => item?._id || item?.id));
    } else {
      setSelectedUsers([]);
    }
  };
  const columns = [
    {
      key: "fullName",
      name: "Full Name",
      // sort: true,
      render: (row) => <span className="capitalize">{row?.fullName}</span>,
    },
    {
      key: "email",
      name: "Email",
      // sort: true,
      render: (row) => <span>{row?.email}</span>,
    },
    {
      key: "status",
      name: "Status",
      render: (row) => (
        <div
          className=""
          onClick={() =>
            methodModel.hasPermission(user, shared.permissionKey, "edit")
              ? statusChange(row)
              : null
          }
        >
          <span
            className={`w-fit min-w-[68px] text-center cursor-pointer text-xs !px-3 py-1 flex items-center justify-center hover:opacity-80 border !rounded-full capitalize ${row.status == "inactive" ? "bg-[#ffefef] text-[#ff3b3b] border-[#ffa6a6]" : "bg-[#E5F9E6] text-[#00BF06] border-[#ADE6AF]"}`}
          >
            {row.status == "inactive" ? "inactive" : "active"}
          </span>
        </div>
      ),
    },
    {
      key: "action",
      name: "Action",
      render: (itm) => (
        <div className="flex items-center justify-start gap-1.5">
          <Tooltip placement="top" title="View">
            <a
              onClick={(e) => view(itm?.id || itm?._id)}
              className="cursor-pointer rounded-full w-8 h-8 flex items-center justify-center text-sm hover:opacity-80 bg-[#E5EFFD] text-[#005AEF]"
            >
              <FaEye />
            </a>
          </Tooltip>
          {methodModel.hasPermission(user, shared.permissionKey, "edit") && (
            <Tooltip placement="top" title="Edit">
              <a
                onClick={(e) => edit(itm?.id || itm?._id)}
                className="cursor-pointer rounded-full w-8 h-8 flex items-center justify-center text-sm hover:opacity-80 bg-[#F2F2F2] text-[#797979]"
              >
                <FaEdit />
              </a>
            </Tooltip>
          )}
          {methodModel.hasPermission(user, shared.permissionKey, "delete") && (
            <Tooltip placement="top" title="Delete">
              <span
                onClick={() => deleteItem(itm?.id || itm?._id)}
                className="cursor-pointer rounded-full w-8 h-8 flex items-center justify-center text-sm hover:opacity-80 bg-[#F8E0DE] text-[#EE5B4F]"
              >
                <MdDelete />
              </span>
            </Tooltip>
          )}
        </div>
      ),
    },
  ];

  const CardSendHandler = () => {
    loader(true);
    ApiClient.get(`user/card/send/multiple`, {
      userId: SelectedUsers?.toString(),
    }).then((res) => {
      if (res?.success) {
        toast.success("Card Sent Successfully");
        setSelectedUsers([]);
      }
      loader(false);
    });
  };

  return (
    <Layout>
      <div className="flex flex-wrap justify-between items-center gap-y-4 mb-5">
        <div>
          <h3 className="text-2xl font-semibold text-[#111827]">
            {shared.title}
          </h3>
        </div>
        <div className="flex">
          {methodModel.hasPermission(user, shared.permissionKey, "edit") && (
            <Link
              className="bg-primary leading-10 h-10 flex justify-center  items-center shadow-btn px-6 hover:opacity-80 text-sm text-white rounded-full gap-1 cursor-pointer min-w-[94px]"
              to={`/${shared.url}/add`}
            >
              <FiPlus className="text-lg text-white" /> Add
              {shared.addTitle}
            </Link>
          )}
        </div>
      </div>

      <div className="">
        <div className="flex items-center flex-wrap gap-2 mb-4">
          {SelectedUsers?.length ? (
            <div
              className="flex justify-content-between cursor-pointer"
              onClick={() => CardSendHandler()}
            >
              <p className="bg-primary pointer-cursor leading-10 mr-3 h-10 flex items-center shadow-btn px-6 hover:opacity-80 text-sm text-white rounded-lg gap-2 cursor-pointer">
                <TbSend className="text-lg text-white" /> Send Card
              </p>
            </div>
          ) : null}
          <form
            className="flex items-center max-w-sm gap-2"
            onSubmit={(e) => {
              e.preventDefault();
              filter();
            }}
          >
            <label htmlFor="simple-search" className="sr-only">
              Search
            </label>
            <div className="relative w-full">
              <input
                type="text"
                id="simple-search"
                value={filters.search}
                onChange={(e) => {
                  setFilter({ ...filters, search: e.target.value });
                  if (e.target.value == "") filter({ search: "" });
                }}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-full focus:ring-orange-500 focus:border-[#063688] block w-full dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-orange-500 dark:focus:border-orange-500 h-10 px-5 pr-11"
                placeholder="Search....."
              />
              {filters?.search && (
                <i
                  className="fa fa-times absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 text-sm"
                  aria-hidden="true"
                  onClick={(e) => clear()}
                />
              )}
              <button
                type="submit"
                className="text-[#2D2D2D] absolute top-[13px] right-[15px] hover:opacity-80"
              >
                <svg
                  className="w-4 h-4"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 20 20"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                  />
                </svg>
                <span className="sr-only">Search</span>
              </button>
            </div>
          </form>
          <div className="flex gap-2 ml-auto flex-wrap">
            {/* Global Date Filter */}
            <div className="flex items-center gap-3">
              <DateRangePicker
                ranges={DateFilters}
                onChange={handleDateRangeChange}
                dateFilterApplied={!!filters?.dateFilterApplied}
              />
            </div>
            <SelectDropdown
              id="statusDropdown"
              displayValue="name"
              placeholder="All Status"
              theme="search"
              isClearable={false}
              intialValue={filters.status}
              result={(e) => {
                changestatus(e.value);
              }}
              options={statusModel.StatusList}
            />
            {/* {filters.status ? (
              <button
                onClick={() => clear()}
                className="bg-primary leading-10 h-10 inline-block shadow-btn px-6 hover:opacity-80 text-sm text-white rounded-lg"
              >
                Reset
              </button>
            ) : (
              <></>
            )} */}
            {filters.status || filters.dateFilterApplied ? (
              <button
                onClick={() => clear()}
                className="bg-primary leading-10 h-10 inline-block shadow-btn px-6 hover:opacity-80 text-sm text-white rounded-lg"
              >
                Reset
              </button>
            ) : (
              <></>
            )}
          </div>
        </div>
        {isDateSelecting ? (
          <div className="mb-3 min-h-[300px] flex items-center justify-center border border-dashed border-gray-200 rounded-xl bg-gray-50">
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-[#CC9900]/10 flex items-center justify-center">
                <svg
                  className="w-6 h-6 text-[#CC9900]"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M8 7V3m8 4V3M5 11h14M7 21h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v12a2 2 0 002 2z"
                  />
                </svg>
              </div>

              <h3 className="text-base font-semibold text-gray-700">
                Select an end date
              </h3>

              <p className="text-sm text-gray-400 mt-1">
                Please select an end date to apply the date filter.
              </p>
            </div>
          </div>
        ) : !loaging ? (
          <Table
            className="mb-3"
            data={data}
            columns={columns}
            page={filters.page}
            count={filters.count}
            filters={filters}
            total={total}
            result={(e) => {
              if (e.event == "page") pageChange(e.value);

              if (e.event == "sort") {
                sorting(e.value);
                sortClass(e.value);
              }

              if (e.event == "count") count(e.value);
            }}
          />
        ) : (
          <></>
        )}
      </div>

      {/* How It Works Guide Modal */}
      <CustomModal
        open={isHelpModalVisible}
        onClose={() => setIsHelpModalVisible(false)}
        width={650}
      >
        <div className="flex flex-col font-sans">
          {/* Header */}
          <div className="bg-gradient-to-r from-[#CC9900] via-[#E6B800] to-[#CC9900] p-6 text-white relative">
            <div className="flex justify-between items-start gap-4">
              <div>
                <h3 className="text-xl font-bold leading-snug">
                  💡 How User Management Works
                </h3>
                <p className="text-sm text-white/90 mt-1">
                  Understanding registered user profiles and management controls
                </p>
              </div>
            </div>
          </div>

          {/* Ticket Dotted Separator */}
          <div className="relative bg-gray-50" style={{ height: "28px" }}>
            <svg
              className="absolute left-0 top-0 h-full"
              style={{ width: "14px" }}
              viewBox="0 0 14 28"
              preserveAspectRatio="none"
            >
              <path d="M0,0 C14,0 14,28 0,28 Z" fill="white" />
            </svg>
            <div
              className="absolute"
              style={{
                top: "50%",
                left: "14px",
                right: "14px",
                transform: "translateY(-50%)",
                borderTop: "1.5px dashed #d1d5db",
              }}
            />
            <svg
              className="absolute right-0 top-0 h-full"
              style={{ width: "14px" }}
              viewBox="0 0 14 28"
              preserveAspectRatio="none"
            >
              <path d="M14,0 C0,0 0,28 14,28 Z" fill="white" />
            </svg>
          </div>

          {/* Modal Body */}
          <div className="p-6 space-y-6">
            <p className="text-sm text-gray-600 leading-relaxed">
              This panel displays all user profiles registered on the TavLoy
              platform who actively use the customer mobile application.
            </p>

            <div className="space-y-4">
              {/* Profile Tracking */}
              <div className="flex gap-4 p-4 rounded-xl border border-[#CC9900]/20 bg-[#CC9900]/5">
                <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-[#CC9900]/10 text-[#CC9900] flex-shrink-0 font-bold text-sm">
                  1
                </span>
                <div>
                  <h4 className="font-bold text-[#8B6E1E] text-sm mb-1">
                    Registered User Profiles
                  </h4>
                  <p className="text-xs text-gray-600 leading-relaxed">
                    View customer details such as full name, email address, and
                    account status. This is the master list of all customers
                    signed up to use the mobile app.
                  </p>
                </div>
              </div>

              {/* Status Toggling */}
              <div className="flex gap-4 p-4 rounded-xl border border-gray-200 bg-gray-50">
                <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-gray-200/50 text-gray-500 flex-shrink-0 font-bold text-sm">
                  2
                </span>
                <div>
                  <h4 className="font-bold text-gray-700 text-sm mb-1">
                    Status Controls (Active / Inactive)
                  </h4>
                  <p className="text-xs text-gray-600 leading-relaxed">
                    Click the **Status** badge to toggle user accounts.
                    Deactivating an account prevents that customer from logging
                    in or using their loyalty perks.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="bg-gray-50 px-6 py-4 border-t border-gray-100 flex justify-end">
            <button
              onClick={() => setIsHelpModalVisible(false)}
              className="px-5 py-2 rounded-xl border border-gray-200 text-gray-600 hover:bg-gray-100 transition-all text-xs font-semibold"
            >
              Got it, thanks!
            </button>
          </div>
        </div>
      </CustomModal>

      {/* Floating Help Button */}
      <Tooltip placement="left" title="How It Works">
        <button
          type="button"
          onClick={() => setIsHelpModalVisible(true)}
          className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-12 h-12 rounded-full bg-[#CC9900] text-white shadow-lg hover:bg-[#B38000] hover:scale-110 active:scale-95 transition-all duration-300"
        >
          <FiHelpCircle className="text-2xl" />
        </button>
      </Tooltip>
    </Layout>
  );
}

export default Html;
